import React from "react";
import styled from "styled-components";
import { to12hr } from "../Helpers/timeIntervals";
import { getStatusColor } from "./Functions";

const TimeSummary = (props) => {
	return (
		<Wrapper>
			<div
				className={`tag mr-1 mb-1 is-${getStatusColor(
					props?.transaction?.status,
				)}`}
			>
				{to12hr(props?.time_summary?.start_time)} -{" "}
				{to12hr(props?.time_summary?.end_time)}
			</div>
			{props?.time_summary?.break_duration > 0 && (
				<div className="tag mr-1 mb-1 is-danger">
					{props?.time_summary?.break_duration} mins break
				</div>
			)}
		</Wrapper>
	);
};

export default TimeSummary;


const Wrapper = styled.div`
    div:first-child {
        color: #000 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.65;
        font-size: 0.8rem;
        font-weight: 600;
    }
    div:last-child {
        color: #fff !important;
    }
`;